import { render, staticRenderFns } from "./NarliFerryboatStatsByProcessTypeTotalGraph.vue?vue&type=template&id=e9dc651a&"
import script from "./NarliFerryboatStatsByProcessTypeTotalGraph.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByProcessTypeTotalGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports